const VIEW = 'view';
const SHOW = 'show';
const CREATE = 'create';
const UPDATE = 'update';
const DELETE = 'delete';
const EXPORT = 'export';
const MANAGE = 'manage';
const FINALIZE = 'finalize';
const ASSIGN = 'assign';
const PRINT = 'print';
const PREVIEW = 'preview';
const CHANGE_STATUS = 'change_status';
const WORK_ORDER_CALENDAR_ACCESS = [
  'work_orders.detail.view',
];

const buildPermissions = (moduleKey, submoduleKey, actions) => actions.map((action) => `${moduleKey}.${submoduleKey}.${action}`);

export const PERMISSION_CATALOG = {
  work_orders: {
    label: 'Ordenes de trabajo',
    submodules: {
      detail: buildPermissions('work_orders', 'detail', [
        VIEW,
        SHOW,
        CREATE,
        UPDATE,
        DELETE,
        PREVIEW,
        PRINT,
      ]),
      signatories: buildPermissions('work_orders', 'signatories', [VIEW, UPDATE]),
    },
  },
  reports: {
    label: 'Reportes',
    submodules: {
      expenses_by_truck: buildPermissions('reports', 'expenses_by_truck', [VIEW, EXPORT]),
      expenses_by_suppliers: buildPermissions('reports', 'expenses_by_suppliers', [VIEW, EXPORT]),
      historical_expenses: buildPermissions('reports', 'historical_expenses', [VIEW, EXPORT]),
      expenses_by_category: buildPermissions('reports', 'expenses_by_category', [VIEW, EXPORT]),
      expenses_by_month: buildPermissions('reports', 'expenses_by_month', [VIEW, EXPORT]),
      equipment_availability: buildPermissions('reports', 'equipment_availability', [VIEW, EXPORT]),
      documentation_alerts: buildPermissions('reports', 'documentation_alerts', [VIEW, EXPORT]),
      equipment_assignment: buildPermissions('reports', 'equipment_assignment', [VIEW, EXPORT]),
      available_equipment: buildPermissions('reports', 'available_equipment', [VIEW, EXPORT]),
    },
  },
  inventory: {
    label: 'Insumos',
    submodules: {
      supplies: buildPermissions('inventory', 'supplies', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'inventory.supplies.show',
      ]),
      imports: buildPermissions('inventory', 'imports', [VIEW, CREATE, DELETE]),
      categories: buildPermissions('inventory', 'categories', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'inventory.categories.show',
      ]),
    },
  },
  warehouse: {
    label: 'Bodegas',
    submodules: {
      warehouses: buildPermissions('warehouse', 'warehouses', [VIEW, SHOW, CREATE, UPDATE, DELETE]),
      stock: buildPermissions('warehouse', 'stock', [VIEW, UPDATE]),
      purchase_orders: buildPermissions('warehouse', 'purchase_orders', [VIEW, SHOW, CREATE, CHANGE_STATUS, DELETE]),
      entries: buildPermissions('warehouse', 'entries', [VIEW, CREATE, EXPORT]),
      exits: buildPermissions('warehouse', 'exits', [VIEW, CREATE]),
      movement_history: buildPermissions('warehouse', 'movement_history', [VIEW, EXPORT]),
      transactions: buildPermissions('warehouse', 'transactions', [VIEW]),
    },
  },
  procurement: {
    label: 'Compras',
    submodules: {
      purchase_orders: [
        'procurement.purchase_orders.view',
        'procurement.purchase_orders.create',
        'procurement.purchase_orders.approve',
        'procurement.purchase_orders.download',
      ],
    },
  },
  maintenance_alerts: {
    label: 'Alertas',
    submodules: {
      alerts: buildPermissions('maintenance_alerts', 'alerts', [VIEW, CREATE, UPDATE, DELETE]),
      categories: buildPermissions('maintenance_alerts', 'categories', [VIEW, CREATE, UPDATE, DELETE]),
      statuses: buildPermissions('maintenance_alerts', 'statuses', [VIEW, UPDATE]),
    },
  },
  providers: {
    label: 'Proveedores',
    submodules: {
      providers: buildPermissions('providers', 'providers', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'providers.providers.show',
      ]),
      services: buildPermissions('providers', 'services', [VIEW, CREATE, UPDATE, DELETE]),
      service_categories: buildPermissions('providers', 'service_categories', [VIEW, CREATE, UPDATE, DELETE]),
    },
  },
  specialists: {
    label: 'Especialistas',
    submodules: {
      specialists: buildPermissions('specialists', 'specialists', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'specialists.specialists.show',
      ]),
      types: buildPermissions('specialists', 'types', [VIEW, CREATE, UPDATE, DELETE]),
    },
  },
  drivers: {
    label: 'Conductores',
    submodules: {
      drivers: buildPermissions('drivers', 'drivers', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'drivers.drivers.show',
      ]),
    },
  },
  clients: {
    label: 'Clientes',
    submodules: {
      clients: buildPermissions('clients', 'clients', [VIEW, CREATE, UPDATE, DELETE]),
      faenas: buildPermissions('clients', 'faenas', [VIEW, CREATE, UPDATE, DELETE]),
    },
  },
  rental_contracts: {
    label: 'Contratos / Arriendos',
    submodules: {
      contracts: buildPermissions('rental_contracts', 'contracts', [VIEW, CREATE, UPDATE, DELETE]),
      equipments: buildPermissions('rental_contracts', 'equipments', [VIEW, CREATE, UPDATE, DELETE]),
      documents: buildPermissions('rental_contracts', 'documents', [VIEW, CREATE, UPDATE, DELETE]),
      history: buildPermissions('rental_contracts', 'history', [VIEW]),
      delivery_certificate: buildPermissions('rental_contracts', 'delivery_certificate', [VIEW, CREATE, UPDATE]),
      reception_certificate: buildPermissions('rental_contracts', 'reception_certificate', [VIEW, CREATE, UPDATE]),
    },
  },
  rental_checklists: {
    label: 'Checklist',
    submodules: {
      templates: buildPermissions('rental_checklists', 'templates', [VIEW, CREATE, UPDATE, DELETE]),
      questions: buildPermissions('rental_checklists', 'questions', [VIEW, CREATE, UPDATE, DELETE]),
      executions: buildPermissions('rental_checklists', 'executions', [VIEW, CREATE, UPDATE, FINALIZE, DELETE]),
    },
  },
  coupleds: {
    label: 'Carros',
    submodules: {
      coupleds: buildPermissions('coupleds', 'coupleds', [VIEW, CREATE, UPDATE, DELETE]),
    },
  },
  users: {
    label: 'Usuarios',
    submodules: {
      users: buildPermissions('users', 'users', [VIEW, SHOW, CREATE, UPDATE, DELETE]),
      roles: buildPermissions('users', 'roles', [VIEW, CREATE, UPDATE, DELETE, ASSIGN]),
      permissions: buildPermissions('users', 'permissions', [VIEW, CREATE, UPDATE, DELETE, ASSIGN]),
    },
  },
  trucks: {
    label: 'Equipos',
    submodules: {
      trucks: buildPermissions('trucks', 'trucks', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'trucks.trucks.import',
        'trucks.trucks.show',
      ]),
      documents: buildPermissions('trucks', 'documents', [VIEW, CREATE, UPDATE, DELETE]).concat([
        'trucks.documents.show',
      ]),
      brands: buildPermissions('trucks', 'brands', [VIEW, CREATE, UPDATE, DELETE]),
      types: buildPermissions('trucks', 'types', [VIEW, CREATE, UPDATE, DELETE]),
      cost_centers: buildPermissions('trucks', 'cost_centers', [VIEW, CREATE, UPDATE, DELETE]),
    },
  },
  settings: {
    label: 'Configuracion',
    submodules: {
      work_orders: buildPermissions('settings', 'work_orders', [VIEW, MANAGE]),
    },
  },
};

export const ROUTE_PERMISSION_MATCHERS = [
  { match: /^\/ordenes-de-trabajo$/, anyOf: WORK_ORDER_CALENDAR_ACCESS },
  { match: /^\/historial-ordenes-de-trabajo$/, permission: 'work_orders.detail.view' },
  { match: /^\/reportes\/expenses-by-truck$/, permission: 'reports.expenses_by_truck.view' },
  { match: /^\/reportes\/expenses-by-suppliers$/, permission: 'reports.expenses_by_suppliers.view' },
  { match: /^\/reportes\/historical-expenses$/, permission: 'reports.historical_expenses.view' },
  { match: /^\/reportes\/expenses-by-category$/, permission: 'reports.expenses_by_category.view' },
  { match: /^\/reportes\/expenses-by-month$/, permission: 'reports.expenses_by_month.view' },
  { match: /^\/reportes\/equipment-availability$/, permission: 'reports.equipment_availability.view' },
  { match: /^\/reportes\/documentation-alerts$/, permission: 'reports.documentation_alerts.view' },
  { match: /^\/reportes\/equipment-assignment$/, permission: 'reports.equipment_assignment.view' },
  { match: /^\/reportes\/available-equipment$/, permission: 'reports.available_equipment.view' },
  { match: /^\/inventario$/, permission: 'inventory.supplies.view' },
  {
    match: /^\/insumo\/[^/]+$/,
    permission: 'inventory.supplies.show',
  },
  { match: /^\/nuevo-insumo$/, permission: 'inventory.supplies.create' },
  { match: /^\/warehouse$/, permission: 'warehouse.warehouses.view' },
  { match: /^\/warehouse\/create$/, permission: 'warehouse.warehouses.create' },
  { match: /^\/warehouse\/[^/]+$/, permission: 'warehouse.warehouses.show' },
  { match: /^\/warehouse\/[^/]+\/stock$/, permission: 'warehouse.stock.view' },
  { match: /^\/warehouse\/[^/]+\/purchases-orders$/, permission: 'warehouse.purchase_orders.view' },
  {
    match: /^\/warehouse\/[^/]+\/purchases$/,
    permission: 'warehouse.entries.view',
  },
  {
    match: /^\/warehouse\/[^/]+\/sales$/,
    permission: 'warehouse.exits.view',
  },
  { match: /^\/warehouse\/[^/]+\/movement-orders$/, permission: 'warehouse.movement_history.view' },
  { match: /^\/ordenes-de-compra$/, permission: 'procurement.purchase_orders.view' },
  { match: /^\/ordenes-de-compra\/crear$/, permission: 'procurement.purchase_orders.create' },
  { match: /^\/ordenes-de-compra\/[^/]+$/, permission: 'procurement.purchase_orders.view' },
  { match: /^\/maintenance-alerts$/, permission: 'maintenance_alerts.alerts.view' },
  { match: /^\/provider$/, permission: 'providers.providers.view' },
  { match: /^\/provider\/create$/, permission: 'providers.providers.create' },
  { match: /^\/provider\/[^/]+\/services$/, permission: 'providers.services.view' },
  { match: /^\/provider\/[^/]+$/, permission: 'providers.providers.show' },
  { match: /^\/specialists$/, permission: 'specialists.specialists.view' },
  { match: /^\/specialists\/create$/, permission: 'specialists.specialists.create' },
  { match: /^\/specialists\/[^/]+$/, permission: 'specialists.specialists.show' },
  { match: /^\/drivers$/, permission: 'drivers.drivers.view' },
  { match: /^\/drivers\/create$/, permission: 'drivers.drivers.create' },
  { match: /^\/drivers\/[^/]+$/, permission: 'drivers.drivers.show' },
  { match: /^\/clients$/, permission: 'clients.clients.view' },
  { match: /^\/clients\/create$/, permission: 'clients.clients.create' },
  { match: /^\/clients\/[^/]+$/, permission: 'clients.clients.view' },
  { match: /^\/clients\/[^/]+\/faenas$/, permission: 'clients.faenas.view' },
  { match: /^\/clients\/[^/]+\/history$/, permission: 'clients.clients.view' },
  { match: /^\/rental-contracts$/, permission: 'rental_contracts.contracts.view' },
  { match: /^\/rental-contracts\/create$/, permission: 'rental_contracts.contracts.create' },
  { match: /^\/rental-contracts\/checklist-questions$/, permission: 'rental_checklists.questions.view' },
  { match: /^\/rental-contracts\/checklists$/, permission: 'rental_checklists.templates.view' },
  { match: /^\/rental-contracts\/checklists\/create$/, permission: 'rental_checklists.templates.create' },
  { match: /^\/rental-contracts\/checklists\/[^/]+$/, permission: 'rental_checklists.templates.view' },
  { match: /^\/rental-contracts\/[^/]+\/equipments$/, permission: 'rental_contracts.equipments.view' },
  { match: /^\/rental-contracts\/[^/]+\/checklists$/, permission: 'rental_checklists.executions.view' },
  { match: /^\/rental-contracts\/[^/]+\/history$/, permission: 'rental_contracts.history.view' },
  { match: /^\/rental-contracts\/[^/]+\/documents$/, permission: 'rental_contracts.documents.view' },
  { match: /^\/rental-contracts\/[^/]+\/delivery-certificate$/, permission: 'rental_contracts.delivery_certificate.view' },
  { match: /^\/rental-contracts\/[^/]+\/reception-certificate$/, permission: 'rental_contracts.reception_certificate.view' },
  { match: /^\/rental-contracts\/[^/]+$/, permission: 'rental_contracts.contracts.view' },
  { match: /^\/coupleds$/, permission: 'coupleds.coupleds.view' },
  { match: /^\/coupleds\/create$/, permission: 'coupleds.coupleds.create' },
  { match: /^\/coupleds\/[^/]+$/, permission: 'coupleds.coupleds.view' },
  { match: /^\/users$/, permission: 'users.users.view' },
  { match: /^\/users\/create$/, permission: 'users.users.create' },
  { match: /^\/users\/[^/]+$/, permission: 'users.users.show' },
  { match: /^\/truck$/, permission: 'trucks.trucks.view' },
  { match: /^\/truck\/create$/, permission: 'trucks.trucks.create' },
  { match: /^\/truck\/[^/]+$/, permission: 'trucks.trucks.show' },
  { match: /^\/truck\/[^/]+\/documentation$/, permission: 'trucks.documents.view' },
];

export const DEFAULT_PERMISSION_ROUTE_PRIORITY = [
  { path: '/ordenes-de-trabajo', anyOf: WORK_ORDER_CALENDAR_ACCESS },
  { path: '/inventario', permission: 'inventory.supplies.view' },
  { path: '/truck', permission: 'trucks.trucks.view' },
  { path: '/reportes/expenses-by-truck', permission: 'reports.expenses_by_truck.view' },
  { path: '/warehouse', permission: 'warehouse.warehouses.view' },
  { path: '/ordenes-de-compra', permission: 'procurement.purchase_orders.view' },
  { path: '/maintenance-alerts', permission: 'maintenance_alerts.alerts.view' },
  { path: '/provider', permission: 'providers.providers.view' },
  { path: '/specialists', permission: 'specialists.specialists.view' },
  { path: '/drivers', permission: 'drivers.drivers.view' },
  { path: '/clients', permission: 'clients.clients.view' },
  { path: '/rental-contracts', permission: 'rental_contracts.contracts.view' },
  { path: '/rental-contracts/checklists', permission: 'rental_checklists.templates.view' },
  { path: '/coupleds', permission: 'coupleds.coupleds.view' },
  { path: '/users', permission: 'users.users.view' },
  { path: '/users/:id', permission: 'users.users.show' },
];

export function flattenPermissionCatalog() {
  return Object.values(PERMISSION_CATALOG).flatMap(
    (moduleConfig) => Object.values(moduleConfig.submodules).flatMap(
      (permissions) => permissions,
    ),
  );
}
